module.exports = __webpack_public_path__ + "img/materials-2_cn.e931696.jpg";